import { Component } from 'react'

// Does absolutely nothing! except preventing child components from rendering
// Can be used as an inline comment-out feature.
class Null extends Component {
  render () { return null }
}

export default (Null)



// WEBPACK FOOTER //
// ./src/app/shared/elements/null/index.js